(ns ui.cofx.response
  (:require
   [re-frame.core :as rf]
   [oops.core :as oops]
   [ui.fx.fetch :as fetch-fx]))

(defn valid-context?
  [ctx]
  (and (map? ctx)
       (or (contains? ctx :state-path) ;; Nev event context
           (contains? ctx :card-state-path) ;; Card event context
           ;; Add more rules if needed
           )))

(rf/reg-cofx
 ::stale-response?
 (fn [cofx]
   (let [{:keys [original-event]} cofx
         last-event-arg (last original-event)
         fetch-response-event? (fetch-fx/fetch-response-map? last-event-arg)
         ctx (second original-event)
         _ (when-not (valid-context? ctx)
             (throw (ex-info "Context not valid in stale-reponse? -interceptor"
                             {:original-event original-event})))
         signal (:signal ctx)
         stale-response? (or (when signal
                               (oops/oget signal "aborted"))
                             (when fetch-response-event?
                               (:aborted? last-event-arg)))]
     (assoc cofx :stale-response? stale-response?))))

(def stale-response? (rf/inject-cofx ::stale-response?))
